(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const money = (cents) => new Intl.NumberFormat(window.nz.locale, { style: 'currency', currency: window.nz.currency }).format(cents / 100);

  /* Toast */
  let toastTimer;
  const toast = (html) => {
    const el = $('[data-toast]'); if (!el) return;
    el.innerHTML = html; el.classList.add('is-on');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => el.classList.remove('is-on'), 3800);
  };
  const toastCart = (msg) => toast(`<span>${msg}</span><a href="${window.nz.cartUrl}">Ver carrinho</a>`);

  /* Menu mobile */
  const toggle = $('[data-nav-toggle]'), nav = $('[data-nav]');
  if (toggle && nav) {
    const set = (open) => { nav.classList.toggle('is-open', open); toggle.setAttribute('aria-expanded', open); };
    toggle.addEventListener('click', () => set(!nav.classList.contains('is-open')));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && set(false));
    document.addEventListener('click', (e) => { if (nav.classList.contains('is-open') && !nav.contains(e.target) && !toggle.contains(e.target)) set(false); });
  }

  /* Contador do carrinho */
  const refreshCount = async () => {
    const cart = await (await fetch('/cart.js')).json();
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    return cart;
  };

  const addToCart = async (body) => {
    const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || 'Não foi possível adicionar.');
    await refreshCount();
    return data;
  };

  /* Adição rápida nos cards */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-add]'); if (!btn) return;
    btn.classList.add('is-loading');
    try {
      const fd = new FormData(); fd.append('id', btn.dataset.quickAdd); fd.append('quantity', 1);
      await addToCart(fd); toastCart('Adicionado ao carrinho');
    } catch (err) { toast(err.message); }
    btn.classList.remove('is-loading');
  });

  /* Página de produto */
  const section = $('[data-product-section]');
  if (section) {
    const product = JSON.parse($('[data-product-json]', section).textContent);
    const form = $('#product-form', section);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-btn]', form);
    const err = $('[data-form-error]', form);
    const fieldsets = $$('.opt', form);

    const showMedia = (id) => {
      $$('.pg__item', section).forEach((el) => el.classList.toggle('is-active', el.dataset.mediaId == id));
      $$('.pg__thumb', section).forEach((el) => el.classList.toggle('is-active', el.dataset.thumb == id));
    };
    $$('.pg__thumb', section).forEach((b) => b.addEventListener('click', () => showMedia(b.dataset.thumb)));

    const update = () => {
      if (!fieldsets.length) return;
      const chosen = fieldsets.map((f) => $('input:checked', f)?.value);
      fieldsets.forEach((f, i) => { $('[data-opt-label]', f).textContent = chosen[i]; });
      const v = product.variants.find((x) => x.options.every((o, i) => o === chosen[i]));
      if (!v) { addBtn.disabled = true; addBtn.textContent = 'Indisponível'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? 'Adicionar ao carrinho' : 'Esgotado';
      const now = $('[data-price-now]', section), was = $('[data-price-was]', section);
      now.textContent = money(v.price);
      if (v.compare_at_price > v.price) { was.textContent = money(v.compare_at_price); was.hidden = false; } else { was.hidden = true; }
      if (v.featured_media) showMedia(v.featured_media.id);
      history.replaceState(null, '', `${location.pathname}?variant=${v.id}`);
    };
    form.addEventListener('change', (e) => e.target.type === 'radio' && update());

    const qty = $('input[name=quantity]', form);
    $('[data-qty-minus]', form).addEventListener('click', () => { qty.value = Math.max(1, +qty.value - 1); });
    $('[data-qty-plus]', form).addEventListener('click', () => { qty.value = +qty.value + 1; });

    form.addEventListener('submit', async (e) => {
      e.preventDefault(); err.hidden = true;
      if (addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      try { await addToCart(new FormData(form)); toastCart('Adicionado ao carrinho'); }
      catch (ex) { err.textContent = ex.message; err.hidden = false; }
      addBtn.classList.remove('is-loading');
    });
  }

  /* Produtos relacionados */
  const rel = $('[data-related]');
  if (rel && rel.dataset.url) {
    fetch(rel.dataset.url).then((r) => r.text()).then((html) => {
      const inner = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-related]');
      if (inner && inner.innerHTML.trim()) rel.innerHTML = inner.innerHTML; else rel.remove();
    }).catch(() => rel.remove());
  }

  /* Carrinho: alterar quantidade */
  const changeLine = async (line, quantity) => {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    location.reload();
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-change]'); if (b) changeLine(+b.dataset.lineChange, +b.dataset.qty);
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-input]'); if (i) changeLine(+i.dataset.lineInput, Math.max(0, +i.value));
  });

  /* Filtros da coleção */
  const bar = $('[data-auto-submit]');
  if (bar) bar.addEventListener('change', () => bar.submit());
})();
